var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrapper},[_c('h1',{staticClass:"theme-color"},[_vm._v("404")]),_c('span',[_vm._t("default",function(){return [_c('p',[_vm._v("This page doesn't exist.")]),_c('p',[_vm._v(" Go to "),_c('router-link',{attrs:{"to":{
            name: 'dashboard'
          }}},[_vm._v(" home page. ")])],1)]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }